import React from 'react';
import { Heart, Code2 } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-900/80 border-t border-gray-800/50 backdrop-blur-sm py-8">
      <div className="container mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between">
          {/* Left side - Copyright */}
          <div className="text-gray-400 text-sm mb-4 md:mb-0">
            © 2025 Sony Joy. All rights reserved.
          </div>

          {/* Center - Made with love */}
          <div className="flex items-center text-gray-400 text-sm mb-4 md:mb-0">
            <span>Made with</span>
            <Heart className="w-4 h-4 mx-2 text-red-400 fill-current" />
            <span>and</span>
            <Code2 className="w-4 h-4 mx-2 text-blue-400" />
            <span>in Bangalore</span>
          </div>

          {/* Right side - Tech stack */}
          <div className="text-gray-400 text-sm">
            <span className="text-blue-400">React</span> • <span className="text-green-400">Node.js</span> • <span className="text-orange-400">AWS</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;